/**
 * Настройки этапа 1: ссылка на статус и жалоба (§15, §П5.2).
 */

import { useTranslation } from "react-i18next";

export interface SettingsScreenProps {
  readonly onClose: () => void;
  readonly onReport: () => void;
  /** Почта не подтверждена, а баннер закрыт: вернуть напоминание можно отсюда. */
  readonly showVerifyEmail?: boolean;
  readonly onVerifyEmail?: () => void;
  readonly onShowHints?: () => void;
}

export function SettingsScreen({
  onClose,
  onReport,
  showVerifyEmail = false,
  onVerifyEmail,
  onShowHints,
}: SettingsScreenProps): React.JSX.Element {
  const { t } = useTranslation(["support", "common"]);

  return (
    <div className="screen screen--settings">
      <header className="screen__head screen__head--row">
        <h1 className="screen__title">{t("support:settings.title")}</h1>
        <button type="button" className="button" onClick={onClose}>
          {t("common:action.close")}
        </button>
      </header>

      <section className="settings-panel">
        <a className="button button--block" href="/status">
          {t("support:settings.status_link")}
        </a>
        <button type="button" className="button button--block" onClick={onReport}>
          {t("support:settings.report")}
        </button>
        {onShowHints && (
          <button type="button" className="button button--block" onClick={onShowHints}>
            {t("support:settings.hints")}
          </button>
        )}
        {showVerifyEmail && onVerifyEmail && (
          <>
            <button type="button" className="button button--block" onClick={onVerifyEmail}>
              {t("support:settings.verify_email")}
            </button>
            <p className="sheet__hint">{t("support:settings.verify_email.hint")}</p>
          </>
        )}
      </section>
    </div>
  );
}
